<template>
    <div v-if="events.length > 0">
        <div class="text-left">
            <!-- <v-chip class="ma-2" color="accent">
        <v-avatar left>
          <v-icon>event</v-icon>
        </v-avatar>
        <span v-if="curr_month != null"> {{ curr_month }} </span>
        <span v-else> {{ title }} </span>
      </v-chip> -->
            <!-- <v-chip class="ma-2" color="accent" @click="setToday"
        >Go To Today
      </v-chip> -->
        </div>
        <!-- <div class="text-right">
      <v-chip class="ma-2" color="accent">
        <v-icon @click="reload" title="Reload Calendar" dark color="yellow"
          >mdi-reload</v-icon
        >
      </v-chip>
    </div> -->

        <v-sheet tile color="grey lighten-3">
            <v-row dense>
                <v-col cols="12" sm="1" md="1">
                    <v-btn icon class="ma-2" @click="$refs.calendar.prev()">
                        <v-icon>mdi-chevron-left</v-icon>
                    </v-btn>
                </v-col>
                <!-- dropDown menu  -->
                <v-col cols="12" sm="2" md="1">
                    <v-menu>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn outlined color="grey darken-2" v-bind="attrs" v-on="on" class="month-dropDown">
                                <span>{{ typeToLabel[type] }}</span>
                                <v-icon right> mdi-menu-down </v-icon>
                            </v-btn>
                        </template>
                        <v-list>
                            <v-list-item @click="type = 'month'">
                                <v-list-item-title>Month</v-list-item-title>
                            </v-list-item>
                            <v-list-item @click="type = 'week'">
                                <v-list-item-title>Week</v-list-item-title>
                            </v-list-item>
                            <v-list-item @click="type = 'day'">
                                <v-list-item-title>Day</v-list-item-title>
                            </v-list-item>
                        </v-list>
                    </v-menu>
                </v-col>
                <v-col cols="12" sm="1" md="1"></v-col>

                <v-col cols="12" sm="3" md="5">
                    <center>
                        <h1 class="curr-month" v-if="curr_month != null">
                            {{ curr_month }}
                        </h1>
                        <h1 class="curr-month" v-else>{{ title }}</h1>
                    </center>
                </v-col>

                <v-col cols="12" sm="2" md="2" align="right">
                    <v-select v-model="weekday" :items="weekdays" dense outlined hide-details label="weekdays" class="ma-2"></v-select>
                </v-col>

                <v-col cols="12" sm="2" md="1" align="right">
                    <v-chip class="ma-2" color="brand onBrand--text" @click="setToday">Go To Today </v-chip>
                </v-col>

                <v-col cols="12" sm="1" md="1" align="right">
                    <v-btn icon class="ma-2" @click="$refs.calendar.next()">
                        <v-icon>mdi-chevron-right</v-icon>
                    </v-btn>
                </v-col>
            </v-row>
        </v-sheet>
        <v-sheet height="520">
            <v-calendar
                ref="calendar"
                v-model="value"
                :weekdays="weekday"
                color="primary"
                :type="type"
                :events="events"
                :event-overlap-threshold="30"
                :event-color="getEventColor"
                @change="getEvents"
                @click:event="showEvent"
                @click:more="viewDay"
                @click:day="getdata"
            ></v-calendar>
        </v-sheet>
        <template>
            <div class="text-center">
                <v-dialog v-model="dialog" width="500">
                    <v-card>
                        <v-card-title class="headline" primary-title>
                            {{ tempevents.name }}
                        </v-card-title>

                        <v-card-text>
                            <div class="headline mb-2">
                                Description : {{ tempevents.description }}
                            </div>
                            <v-chip class="mr-2" color="lightgreen" text-color="white">
                                <v-icon left>mdi-brightness-5</v-icon>
                                Class: {{ tempevents.std }}
                            </v-chip>
                            <!-- <v-chip class="mr-2" color="lightgreen" text-color="white">
                <v-icon left>mdi-brightness-5</v-icon>
                Division: {{ tempevents.grno }}
              </v-chip> -->
                        </v-card-text>

                        <v-divider></v-divider>

                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="primary" text @click="dialog = false">
                                Close
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
            </div>
        </template>
    </div>
</template>

<script>
    import axios from "axios";
    import { months } from "moment";
    export default {
        data: () => ({
            dialog: false,
            datetime: null,
            title: "",
            type: "month",
            // types: ["month", "week", "day"],
            typeToLabel: {
                month: "Month",
                week: "Week",
                day: "Day",
            },
            mode: "stack",
            modes: ["stack", "column"],
            weekday: [0, 1, 2, 3, 4, 5, 6],
            weekdays: [
                { text: "Sun - Sat", value: [0, 1, 2, 3, 4, 5, 6] },
                { text: "Mon - Sun", value: [1, 2, 3, 4, 5, 6, 0] },
                { text: "Mon - Fri", value: [1, 2, 3, 4, 5] },
            ],
            value: "",
            events: [],
            tempevents: { name: "", description: "", std: "", grno: "" },
            selectedElement: null,

            colors: ["blue", "indigo", "deep-purple", "cyan", "green", "orange", "grey darken-1"],
            names: ["Meeting", "Holiday", "PTO", "Travel", "Event", "Birthday", "Conference", "Party"],
            months: ["", "January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
            curr_month: null,
            ay: "",
            child: "",
        }),

        updated: function () {
            //console.log("Inside updated");
            this.$nextTick().then(() => {
                if (this.$refs.calendar.value != "") {
                    // console.log(this.$refs.calendar.value);
                    let date = this.$refs.calendar.value;
                    var no = date.split("-");
                    // console.log(no[1]);
                    this.curr_month = this.months[parseInt(no[1])];
                    // console.log(this.curr_month);
                }
            });
        },

        methods: {
            viewDay({ date }) {
                this.value = date;
                this.type = "day";
            },

            setToday() {
                this.value = "";
                this.curr_month = null;
                // console.log("title", this.title);
            },
            dateTime() {
                let dt = this.formatDate(this.datetime, true);
                const formData = {
                    datetime: dt,
                };
                // console.log("formData");
                // console.log(formData);
                axios
                    .post("tryNError/dateTime", formData)
                    .then((res) => {
                        if (res.data.msg == "200") {
                        } else {
                        }
                    })
                    .catch((error) => {
                        window.console.log(error);
                    });
            },
            showEvent({ nativeEvent, event }) {
                // console.log("in show event", event);
                this.tempevents.name = event.name;
                this.tempevents.description = event.description;
                this.tempevents.std = event.standard;
                this.tempevents.grno = event.divissionoffering;
                this.selectedElement = nativeEvent.target;

                this.dialog = true;
                console.log(this.selectedElement);

                //alert(event.name + " " + event.description + " " + event.std);
            },
            getdata({ day }) {
                // alert(day)
            },
            getEventData(start) {
                return start == this.value;
            },
            getEvents() {
                //alert(this.value)
            },

            getEventColor(event) {
                return event.color;
            },
            rnd(a, b) {
                return Math.floor((b - a + 1) * Math.random()) + a;
            },
            formatDate(a, withTime) {
                return withTime ? `${a.getFullYear()}-${a.getMonth() + 1}-${a.getDate()} ${a.getHours()}:${a.getMinutes()}` : `${a.getFullYear()}-${a.getMonth() + 1}-${a.getDate()}`;
            },
            getMonthYYYYMMDD(date) {
                var num_month = date.split("-");
                var months = ["", "January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
                return months[parseInt(num_month[1])];
            },
            // reload() {
            //   const data = {
            //     ay: this.ay,
            //     child: this.child,
            //   };
            //   axios
            //     .get("/AcademicPlanner/getChildAcademicPlans", data)
            //     .then((res) => {
            //       if (res.data.flag == "YES") {
            //         console.log("in api");
            //         if (res.data.planning_list.length !== 0) {
            //           this.events = res.data.planning_list;
            //           console.log("in API", this.events);
            //         }
            //         this.title = this.getMonthYYYYMMDD(this.$refs.calendar.start);
            //       } else {
            //       }
            //     })
            //     .catch((error) => {
            //       window.console.log(error);
            //     });
            // },
        },
        mounted() {
            this.ay = JSON.parse(localStorage.getItem("ay"));
            this.child = JSON.parse(localStorage.getItem("child"));

            this.events.push({
                name: "Happy New Year", //title
                start: "2020-01-01", //this.formatDate(res.data.date, !true),

                // start: "2022-05-18", //this.formatDate(res.data.date, !true),
                //   end: "2022-05-20", //this.formatDate(res.data.date, !true),
                color: "",
                description: "",
                // standard: "",
                // divissionoffering: "",
            });
            const data = {
                ay: this.ay,
                child: this.child,
            };
            axios
                .post("/AcademicPlanner/getChildAcademicPlans", data)
                .then((res) => {
                    if (res.data.flag == "YES") {
                        if (res.data.planning_list.length !== 0) {
                            this.events = res.data.planning_list;
                            console.log("in API", this.events);
                        }
                        this.title = this.getMonthYYYYMMDD(this.$refs.calendar.start);
                    } else {
                    }
                })
                .catch((error) => {
                    window.console.log(error);
                });
        },
    };
</script>
<style scoped>
    .month-dropDown {
        margin-top: 2%;
    }

    .curr-month {
        font-size: 30px;
        color: #8c9eff;
        display: inline-block;
        -webkit-transform: scale(1.5, 1); /* Safari and Chrome */
        -moz-transform: scale(1.5, 1); /* Firefox */
        -ms-transform: scale(1.5, 1); /* IE 9 */
        -o-transform: scale(1.5, 1); /* Opera */
    }
</style>
